import { lazy } from "react";
import { Switch, useRouteMatch, Route } from "react-router-dom";
import { LessonPlanProvider } from "../contexts/lesson-plan.context";

const Learning = lazy(() => import("./learning/Learning"));
const LearningStepsWrapper = lazy(() =>
  import("./learning/learning-steps-wrapper.component")
);
const LearningStepAttachmentDetailsWrapper = lazy(() =>
  import("./learning/learningStepAttacmentDetails.wrapper")
);

const LessonPlanRoutes = () => {
  // path=lessonPlan
  const { path } = useRouteMatch();

  return (
    <LessonPlanProvider>
      <Switch>
        <Route path={`${path}/:typeId/:subTypeId`} exact component={Learning} />
        <Route
          path={`${path}/:typeId/:subTypeId/lesson/:learnId`}
          //   path="/lesson/steps/:id/:title"
          exact
          component={LearningStepsWrapper}
        />

        <Route
          path={`${path}/:typeId/:subTypeId/lesson/:learnId/step/:stepId/resource/:resourceId`}
            // path="/lesson/steps/attachments/:stepId/details/:resourceId"
          exact
          component={LearningStepAttachmentDetailsWrapper}
        />
      </Switch>
    </LessonPlanProvider>
  );
};

export default LessonPlanRoutes;
